import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import { formValueSelector, getFormSyncErrors } from "redux-form";
import { useDispatch, useSelector } from "react-redux";
import Container from 'react-bootstrap/Container';
import SafetyMeasure from "../SafetyMeasures/SafetyMeasures";
import BookingForm from "../BookingForm/BookingForm";
import getPaymentMethodsQuery from '../../components/BookingDetail/PriceDetails/PaymentMethod/getAllPaymentMethods.graphql';
import CommonModal from "../Modal/CommonModal";
import SocketContext from "../../core/socketNotifications/SocketContext";
import NearestProviderForm from "../NearestProviderForm/NearestProviderForm";
import ScheduleBookingForm from "../ScheduleBookingForm/ScheduleBookingForm";
import { closeHeaderModal, openHeaderModal } from "../../actions/siteadmin/modalActions";
import { changeBookingError } from "../../actions/booking/changeBookingError";
import showToaster from "../../helpers/toastrMessgaes/showToaster";
import messages from "../../locale/messages";
import scheduleDateSplitUp from "../../helpers/scheduleDateSplitUp";
import ProviderSelectionForm from "../ProviderSelectionForm/ProviderSelectionForm";
import PreferredProviderForm from "../PreferredProviderForm/PreferredProviderForm";

import getAllPrecautionNotification from './getAllPrecautionNotification.graphql';
import useQueryResponse from "../../lib/hooks/useQueryResponse";
import bt from '../commonStyle.css';
import s from "./ConfirmBookingBanner.css";

const ConfirmBookingBanner = ({ loading, data, intl: { formatMessage } }) => {

    const { data: precautionNotification, loading: precautionLoading } = useQueryResponse({
        query: getAllPrecautionNotification,
        fetchPolicy: 'network-only',
        ssr: false
    })

    const { data: paymentMethods, loading: paymentMethodLoading } = useQueryResponse({
        query: getPaymentMethodsQuery,
        fetchPolicy: 'network-only',
        ssr: true
    })
    const dispatch = useDispatch()
    const {
        safetyMeasureForm,
        bookingForm,
        nearestProviderForm,
        scheduleBookingForm,
        bookingError,
        paymentMethodId,
        walletAmount,
        userCardPaymentMethodId,
        fieldErrors,
        fieldErrors2,
        scheduleFrom,
        paypalCurrency,
        providerSelectionForm,
        preferredProviderForm,
        isPreffered
    } = useSelector((state) => {
        const paymentSelector = formValueSelector("PaymentMethod");
        const scheduleSelector = formValueSelector('ScheduleBookingForm');
        return {
            safetyMeasureForm: state.adminModalStatus.safetyMeasureForm,
            bookingForm: state.adminModalStatus.bookingForm,
            nearestProviderForm: state.adminModalStatus.nearestProviderForm,
            scheduleBookingForm: state.adminModalStatus.scheduleBookingForm,
            bookingError: state?.booking?.data?.error,
            paymentMethodId: paymentSelector(state, 'paymentMethodId'),
            walletAmount: paymentSelector(state, 'walletAmount'),
            userCardPaymentMethodId: paymentSelector(state, 'userCardPaymentMethodId'),
            fieldErrors: getFormSyncErrors('OrderDetails')(state),
            scheduleFrom: scheduleSelector(state, 'scheduleFrom'),
            paypalCurrency: paymentSelector(state, 'paypalCurrency'),
            preferredProviderForm: state.adminModalStatus.preferredProviderForm,
            providerSelectionForm: state.adminModalStatus.providerSelectionForm,
            isPreffered: state?.adminModalStatus?.isPreffered
        };

    });

    const closeSafetyMeasureModal = () => {
        dispatch(closeHeaderModal('safetyMeasureForm'));
    }

    const closeBookingFormModal = () => {
        dispatch(closeHeaderModal('bookingForm'));
    }
    const closeNearestProviderFormModal = () => {
        if (isPreffered) dispatch(closeHeaderModal('preferredProviderForm'))
        dispatch(closeHeaderModal('nearestProviderForm'));
        (bookingError === 'Sorry, no service providers available for your order. Please try again.') && window.location.replace('/');
        changeBookingError();
        window.location.replace('/bookings/upcoming')
    }
    const closeScheduleBookingFormModal = () => {
        dispatch(closeHeaderModal('scheduleBookingForm'));
    }

    const closeproviderSelectionForm = () => {
        dispatch(closeHeaderModal('providerSelectionForm'))
    }

    const closepreferredProviderModal = () => {
        dispatch(closeHeaderModal('preferredProviderForm'))
    }

    const handleClick = () => {
        let precautionDetails;
        if (precautionNotification?.getAllPrecautionNotification?.results?.length > 0) {
            precautionDetails = precautionNotification?.getAllPrecautionNotification.results[0];
        }
        const shouldOpenSafetyMeasure = precautionDetails?.isEnabled;
        const selectedPaymentMethod = paymentMethods.getAllPaymentMethods.results.find(method => method.paymentType == paymentMethodId);
        if (paymentMethodId == 5 && !paypalCurrency) {
            showToaster({ messageId: 'selectCurrency', toasterType: 'error' })
            return;
        }
        if (fieldErrors?.description?.defaultMessage) {
            return;
        }
        if (paymentMethodId == 4 || (selectedPaymentMethod && !selectedPaymentMethod?.isEnable)) {
            showToaster({ messageId: 'noPaymentType', toasterType: 'error' });
            return;
        }
        if (paymentMethodId == 3 && (walletAmount == 0 || walletAmount < data?.result?.userPayableFare)) {
            showToaster({ messageId: 'noWalletAmount', toasterType: 'error' });
            return;
        }
        if (paymentMethodId == 2 && (!userCardPaymentMethodId || userCardPaymentMethodId == 0)) {
            showToaster({ messageId: 'noCardDetails', toasterType: 'error' });
            return;
        }

        dispatch(openHeaderModal(shouldOpenSafetyMeasure ? 'safetyMeasureForm' : 'bookingForm'))

    }

    let precautionDetails, formData, safetyMeasuresImage, safetyMeasuresTitle, scheduleInitialValues;
    if (precautionNotification?.getAllPrecautionNotification?.results?.length > 0) {
        precautionDetails = precautionNotification?.getAllPrecautionNotification?.results[0]
    }
    formData = {
        bookingData: data?.result
    }

    scheduleInitialValues = scheduleDateSplitUp(scheduleFrom);

    const shouldOpenSafetyMeasure = precautionDetails?.isEnabled;
    safetyMeasuresTitle = precautionDetails?.title;
    safetyMeasuresImage = precautionDetails?.imageName;

    return (
        <>
            <CommonModal
                title={
                    safetyMeasureForm
                        ? safetyMeasuresTitle
                        : bookingForm ?
                            formatMessage(messages.bookingTitle)
                            : providerSelectionForm
                                ? formatMessage(messages.selectProviderTitle)
                                : preferredProviderForm
                                    ? formatMessage(messages.preferredProviderTitle)
                                    : scheduleBookingForm
                                        ? formatMessage(messages.scheduleYourBooking)
                                        : ''
                }
                onHide={
                    safetyMeasureForm
                        ? closeSafetyMeasureModal
                        : bookingForm
                            ? closeBookingFormModal
                            : providerSelectionForm
                                ? closeproviderSelectionForm
                                : preferredProviderForm
                                    ? closepreferredProviderModal
                                    : nearestProviderForm
                                        ? closeNearestProviderFormModal
                                        : closeScheduleBookingFormModal
                }
                modalStatus={
                    safetyMeasureForm
                        ? safetyMeasureForm
                        : bookingForm ? bookingForm
                            : providerSelectionForm
                                ? providerSelectionForm
                                : preferredProviderForm
                                    ? preferredProviderForm
                                    : nearestProviderForm
                                        ? nearestProviderForm
                                        : scheduleBookingForm
                }

                isBookingBanner={safetyMeasureForm && true}
                safetyMeasuresImage={safetyMeasuresImage}
            >
                {
                    safetyMeasureForm ? (
                        <SafetyMeasure precautionDetails={precautionDetails} />
                    ) : bookingForm ? (
                        <BookingForm
                            formData={formData}
                            shouldOpenSafetyMeasure={shouldOpenSafetyMeasure}
                        />
                    ) : providerSelectionForm ? (
                        <>
                            <ProviderSelectionForm formData={formData} />
                        </>
                    ) : nearestProviderForm ? (
                        <SocketContext.Consumer>
                            {socket => <NearestProviderForm socket={socket} />}
                        </SocketContext.Consumer>
                    ) : preferredProviderForm ? (
                        <SocketContext.Consumer>
                            {socket => <PreferredProviderForm formData={formData} socket={socket} />}
                        </SocketContext.Consumer>
                    ) : (
                        <ScheduleBookingForm
                            formData={formData}
                            initialValues={scheduleInitialValues}
                        />
                    )
                }

            </CommonModal >
            <div className={s.reviewYourRequestContainer}>
                <Container>
                    <div className={s.reviewYourRequestWrapper}>
                        <div onClick={() => handleClick()} className={cx(bt.btnPrimary, bt.cursorPointer, 'loaderButtonFlex')}><FormattedMessage {...messages.confirmBooking} /> </div>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default injectIntl(withStyles(bt, s)(ConfirmBookingBanner));
